const underlyingCsvExtracter = (feed, exchanges, symbols) => {
  // symbol/token,exchange,timestamp,ltp
  let [symbol = '', exchange = '', timestamp = '', ltp = ''] = feed.split(',');

  exchange = exchanges[exchange] ? exchanges[exchange] : exchange;
  symbol = symbols[symbol] ? symbols[symbol] : symbol;
  ltp = ltp === '' ? ltp : Number(ltp);

  return {
    timestamp,
    exchange,
    symbol,
    ltp,
  };
};

export const createFeedObjectFromConversionMap = (
  conversionMap = {},
  feed = ''
) => {
  const underlyingValues = feed.split('|');

  if (!underlyingValues.length) {
    return {};
  }

  const { exchange: exchanges = {}, underlying: symbols = {} } = conversionMap;

  if (!exchanges || !symbols) {
    return {};
  }

  const data = {};

  underlyingValues.forEach((u = '') => {
    const { timestamp, exchange, symbol, ltp } = underlyingCsvExtracter(
      u,
      exchanges,
      symbols
    );

    if (!data[symbol]) {
      data[symbol] = {};
    }

    data[symbol] = {
      timestamp,
      exchange,
      symbol,
      ltp,
    };
  });

  return data;
};

export const updateLiveFeed = (state, action) => {
  const { conversionMap = {} } = state;
  const { exchange: exchanges = {}, underlying: symbols = {} } = conversionMap;
  let { data = {} } = state;
  const { data: feed = '' } = action || {};

  if (!exchanges || !symbols) {
    return state;
  }

  const { timestamp, exchange, symbol, ltp } = underlyingCsvExtracter(
    feed,
    exchanges,
    symbols
  );

  if (!symbol) {
    return state;
  }

  if (!data[symbol]) {
    data[symbol] = {};
  }

  data[symbol] = {
    timestamp,
    exchange,
    symbol,
    ltp,
  };

  return {
    ...state,
    data: data,
  };
};

export const updateUnderlyingMap = (state, action) => {
  const { data = {} } = state;

  const {
    exchange: exchanges = {},
    underlying: symbols = {},
    underlyingLtpPrices = '',
  } = action.data || {};

  if (underlyingLtpPrices && underlyingLtpPrices !== null) {
    const underlyingLastValues = underlyingLtpPrices.split('|');

    if (underlyingLastValues.length) {
      underlyingLastValues.forEach((u = '') => {
        const { timestamp, exchange, symbol, ltp } = underlyingCsvExtracter(
          u,
          exchanges,
          symbols
        );

        if (!data[symbol]) {
          data[symbol] = {};
        }

        data[symbol] = {
          timestamp,
          exchange,
          symbol,
          ltp,
        };
      });
    }
  }

  return {
    ...state,
    data,
    conversionMap: {
      exchange: exchanges,
      underlying: symbols,
    },
  };
};
